































































import ripple from "./ripple.vue"
import tooltip from "./tooltip.vue"
import gbutton from "./button.vue"
import scrollBar from "./scrollBar.vue"
import moveableItem from "./moveableItem.vue"
import calItem from "./calItem.vue"
import loadIcon from "./loadIcon.vue"

import {JobItem} from "../routes/jobView.vue" 
import {frontendClient} from "../lib/client";

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment,{ weekdays } from "moment";
import {nextTick} from "process";

import { setInterval } from "timers";

export interface dayItem{
    dayOfWeek: number,
    date: number,
    children: JobItem[],
    range: number, // 0=start, 1=mid, 2=end
}

@Component({
    components : {
        ripple,
        loadIcon,
        gbutton,
        tooltip,
        scrollBar,
        calItem,
        moveableItem,
    },
})
export default class CalDay extends Vue{

    @Prop({}) properties:dayItem;
    @Prop({}) currentlySelected:number;
    @Prop({}) focusDate:Date;
    @Prop({}) focusWeek:Date[];
    @Prop({}) inCurrentMonth:boolean;
    @Prop({}) daySelector:boolean; // selecting availabilities
    @Prop({}) dateSelector:boolean; // for use with dateSelector.vue
    @Prop({}) isSmall:boolean; // for use in displaying months alone
    @Prop({}) noBorder:boolean;
    @Prop({}) navigation:boolean;

    parentMoveDestination = null;
    isInFocusWeek:boolean = false;
    dayOfWeek:string = "";
    admin:boolean = false;
    date:string = null;
    month:string=null;
    isCurrent:boolean = false;
    isToday:boolean = false;
    isSelected:boolean = false;
    shadowed:boolean = false;
    rangeUpdating:boolean = false;

    calculateNextDay(start: number) {
        return moment(start).add(1,"day").toDate().getTime();
    }

    get currentDay() {
        return moment(this.properties.date).format('DD/MM/YYYY');
    }

    mounted(){
        this.init();
    
        if(frontendClient.userData.rank == "admin"){
            this.admin = true;
        }
    };

    resyncOtherDays(targetUID: string,beforeUID: string | false) {
        this.$route.params.reodering="true";
        let idx = 0;

        let targetChild: JobItem;
        for(let child of this.properties.children) {
            if(child.id === targetUID) {
                targetChild = child;
            }
        }

        if(beforeUID) {
            for(let child of this.properties.children) {
                if(child.id !== targetUID) {
                    if(child.id === beforeUID) {
                        
                        // now send the mutated job
                        if(targetChild) {
                            targetChild.dayPriority[targetChild.relDay] = idx;
                            frontendClient.postEx("jobs/edit",{
                                id: targetChild.id,

                                dayPriority: targetChild.dayPriority,
                            });
                            idx++;
                        }
                        
                        child.dayPriority[child.relDay] = idx;
                        frontendClient.postEx("jobs/edit",{
                            id: child.id,

                            dayPriority: child.dayPriority,
                        });
                    }
                    else {
                        child.dayPriority[child.relDay] = idx;
                        frontendClient.postEx("jobs/edit",{
                            id: child.id,

                            dayPriority: child.dayPriority,
                        });
                    }

                    idx++;
                }
            }
        }
        else {
            for(let child of this.properties.children) {
                if(child.id !== targetUID) {
                    child.dayPriority[child.relDay] = idx;
                    frontendClient.postEx("jobs/edit",{
                        id: child.id,

                        dayPriority: child.dayPriority,
                    });

                    idx++;
                }
            }
            
            // now send the mutated job
            if(targetChild) {
                targetChild.dayPriority[targetChild.relDay] = idx;
                frontendClient.postEx("jobs/edit",{
                    id: targetChild.id,

                    dayPriority: targetChild.dayPriority,
                })
            }
        }
    }

    newDates(newDates, child){
        // something was here
    }

    init(){
        this.establishDate();
        this.manageSelection();
        this.scrollBarInit();
        this.establishDateDetails();
        this.getWeekday();
        this.checkIfToday();
    }

    getWeekday(){
        this.dayOfWeek = moment(this.properties.date).format('dd')
    }

    establishDateDetails(){
        this.month = moment(this.properties.date).format('MMM');
    }

    toggleTopShadow(){
        if((this.$refs.scrollable as HTMLDivElement).scrollTop > 0){
            this.shadowed = true;
        }else{
            this.shadowed = false;
        }
    }

    scrollBarInit(){
        nextTick(() => {
            if(this.$refs.scrollBar) {
                (this.$refs.scrollBar as scrollBar).mountScrollable(this.$refs.scrollable as HTMLDivElement);
            }
            else {
                this.scrollBarInit();
            }
        })
    }

    establishDate(){
        this.date = moment(this.properties.date).format("D");
    }

    checkIfToday(){
        let dayofcalDay = moment(this.properties.date).format('DD/MM/YYYY');
        let currentDay = moment(new Date()).format('DD/MM/YYYY');
        this.isToday = (dayofcalDay == currentDay);
    }
    
    manageSelection(){
        let currentDate = new Date()
        currentDate.setHours(0,0,0,0);
        this.isSelected = false;
        if(this.navigation){
            if(this.currentlySelected && this.properties.date == this.currentlySelected){
                this.isSelected = true;
            }else{
                this.isSelected = false;
            }
            if(this.focusDate && this.properties.date == this.focusDate.getTime()){
                this.isCurrent = false;
            }
        }else{
            this.isFocus();
        }
        this.getFocusWeek();
    }

    isFocus(){
        if(this.properties.date == this.focusDate.getTime()){
            this.isSelected = true;
        }else{
            this.isSelected = false;
        }
    }


    dateFocus(){
        this.$emit("focusDate", this.properties)
    }
    rangeUpdate(){
        this.rangeUpdating = true;
        this.$emit('rangeUpdate', this.properties);
    }

    redirect(route,parameters){
        this.$router.push({ name: route, params: {jobID: parameters}});
    };

    @Watch('currentlySelected')
    updateSelected(to,from){
        this.manageSelection()
    }

    @Watch('properties')
    updateProperties(to, from){
        this.init();
    }  

    @Watch('properties.range')
    rangeHasUpdated(to, from){
        this.rangeUpdating = false;
    }   

    @Watch('focusDate')
    updateFocus(to, from){
        this.isFocus();
    }   

    @Watch('$route.params.walkerappoint')
    getFocusWeek(){
        if(this.$route.params.walkerappoint != "true") return;
        for(let i=0; i<this.focusWeek.length;i++){
            if(this.focusWeek[i].getTime() === this.properties.date){
                this.isInFocusWeek = true;
            }
        }
    }   
}
